// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.individual-details-header {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}

.individual-details-subtitle {
  color: #5c738b;
  font-weight: 600;
}

.individual-details-narrative {
  margin-bottom: 1.25rem;
}

.individual-details-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.individual-details-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.individual-detail-card {
  background: #f8fbff;
  border: 1px solid #e0ebf6;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 100%;
  padding: 1rem;
}

.individual-detail-label {
  color: #5a738c;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.individual-detail-value {
  color: #183a5a;
  font-size: 1rem;
  font-weight: 600;
}

.individual-detail-list {
  display: grid;
  gap: 0.75rem;
}

.individual-detail-item {
  background: #fff;
  border: 1px solid #e7eff8;
  border-radius: 0.9rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding: 0.85rem 0.95rem;
}

.individual-detail-item span {
  color: #556b83;
  font-size: 0.92rem;
}

.individual-detail-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.individual-detail-empty {
  color: #6d8298;
}

@media (max-width: 767px) {
  .individual-details-header {
    align-items: stretch;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/IndividualDetails/IndividualDetails.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;AACF","sourcesContent":[".individual-details-header {\r\n  align-items: flex-start;\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: space-between;\r\n}\r\n\r\n.individual-details-subtitle {\r\n  color: #5c738b;\r\n  font-weight: 600;\r\n}\r\n\r\n.individual-details-narrative {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.individual-details-layout {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.individual-details-badges {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.65rem;\r\n}\r\n\r\n.individual-detail-card {\r\n  background: #f8fbff;\r\n  border: 1px solid #e0ebf6;\r\n  border-radius: 1rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n  height: 100%;\r\n  padding: 1rem;\r\n}\r\n\r\n.individual-detail-label {\r\n  color: #5a738c;\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.individual-detail-value {\r\n  color: #183a5a;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.individual-detail-list {\r\n  display: grid;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.individual-detail-item {\r\n  background: #fff;\r\n  border: 1px solid #e7eff8;\r\n  border-radius: 0.9rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n  padding: 0.85rem 0.95rem;\r\n}\r\n\r\n.individual-detail-item span {\r\n  color: #556b83;\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.individual-detail-chip-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.individual-detail-empty {\r\n  color: #6d8298;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .individual-details-header {\r\n    align-items: stretch;\r\n    flex-direction: column;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
